export const CLASS_NAMES = {
  container:
    'py-3 px-2 md:py-6 md:px-5 border border-neutral-300 shadow-card flex flex-col rounded-lg text-center',
  title: 'text-14-22 text-neutral-600 mb-2 md:mb-4',
  count: 'text-18-28-em md:text-24-28-em text-neutral-900',
};
